import React from 'react';
import { Divider, Typography } from '@mui/material';
import deshiChagol from '../../../../../images/Agri-info/Animals/sagol_ছাগল.jpg';
import useDocumentTitle from '../../../../../hooks/useDocumentTitle';

const DeshiChagolInfo = () => {

    // dynamic title
    useDocumentTitle("দেশি ছাগল");

    return (

        <div className=" rounded-3 bg-white my-4 px-5">
            <Typography
                sx={{
                    textAlign: "center",
                    pb: 2,
                    pt: 3,
                    fontWeight: 600,
                    color: 'rgb(37, 36, 36, 0.83)'
                }}
                variant="h4"
                noWrap
                component="div"
            >
                দেশি ছাগল
            </Typography>
            <Divider />

            <div className="card mt-4 mb-3 border-0 rounded-0">
                <div className="row g-0">
                    <div className="col-md-4">
                        <img src={deshiChagol} className="img-fluid rounded-0 h-100" alt="..." />
                    </div>
                    <div className="col-md-8">
                        <div className="card-body text-start ">
                            <h3><b>দেশি (ব্ল্যাক বেঙ্গল) ছাগল খামার</b></h3>
                            <p className="card-text"><b>দেশি (ব্ল্যাক বেঙ্গল) ছাগল খামার স্থাপনে উন্নত গুলাগুরসম্পন্ন ছাগল নির্বাচন কৌশল<br />ভূমিকা: </b><br />লাভজনক ব্ল্যাক বেঙ্গল ছাগলের খামার স্থাপনে উৎপাদন বৈশিষ্ট্য উনড়বত গুনাগুনসম্পনড়ব ছাগী ও পাঁঠা সংগ্রহ একটি মূল দায়িত্ব হিসেবে বিবেচিত। মাঠ পর্যায়ে বিভিনড়ব বয়সী ছাগী ও পাঁঠা নির্বাচন সফলভাবে পালনের জন্য প্রযুক্তিগত তথ্যাদি সরবরাহ অত্যাবশ্যক।</p>

                        </div>
                    </div>
                </div>
            </div>

            <div className='text-start pb-5'>
                <p className="card-text"><b>প্রযুক্তির বৈশিষ্ট্য/সংক্ষিপ্ত বিবরণ</b><br />বাংলাদেশে বর্তমানে বাণিজ্যিক ছাগল প্রজনন খামার না থাকায় মাঠ পর্যায় হতে ছাগল সংগ্রহ করতে হবে। মাঠ পর্যায়ে ব্যাক বেঙ্গল ছাগল, বাচ্চা ও দুধ উৎপাদন ক্ষমতার ভিনড়বতা বিদ্যমান। উক্ত ভিনড়বতা বংশ অথবা/এবং পরিবেশগত কারণ বা স্বতন্ত্র উৎপাদন দক্ষতার জন্য হতে পারে। সে প্রেক্ষাপটে ব্যাক বেঙ্গল ছাগল খামার প্রতিষ্ঠার জন্য বংশ বিবরণের ভিত্তিতে বাছাই ও নিজস্ব উৎপাদন/পূনরুৎপাদন বৈশিষ্ট্যাবলীর ভিত্তিতে বাছাই বিবেচনায় রেখে ছাগল নির্বাচন করা যেতে পারে।</p>
                <p className="card-text"><b>বংশ বিবরণের ভিত্তিতে বাছাই</b><br />মাঠ পর্যায়ে বংশ বিবরণ পাওয়া দুরূহ। কারণ খামারীরা ছাগলের বংশ বিবরণ লিখিত আকারে সংরক্ষণ করেন না। তবে তাঁদেও সাথে আলোচনা করে একটি ছাগী বা পাঁঠার বংশের উৎপাদন ও পূনরুৎপাদন দক্ষতা সম্বন্ধে ধারনা নেয়া যেতে পারে। ছাগীর মা/দাদী/নানীর প্রতিবারে বাচ্চার সংখ্যা, দৈনিক দুধ উৎপাদন, বয়োপ্রাপ্তির বয়স, বাচ্চার জন্মের ওজন ইত্যাদি সংগ্রহ করা সম্ভব। পাঁঠা নির্বাচনের ক্ষেত্রে পাঁঠার মা/দাদী/নানীর তথ্যাবলীর উপর নির্ভর করা যেতে পারে। একটি উনড়বত বৱ্যাক বেঙ্গল ছাগী/পাঁঠার বংশীয় গুনাগুন নিমড়বরূপ হওয়া প্রয়োজন</p>
                <p className="card-text"><b>নিজস্ব উৎপাদন/পূনরুৎপাদন বৈশিষ্ট্যাবলীর ভিত্তিতে বাছাই</b><br />এ ক্ষেত্রে দু’টি বিষয় বিবেচনা করা প্রয়োজন। ছাগী ও পাঁঠার উৎপাদন এবং পূনরুৎপাদন বৈশিষ্ট্যাবলী এবং এদের দৈহিক বৈশিষ্ট্যাবলী । পাঁঠা নির্বাচনের ক্ষেত্রে উৎপাদন এবং পূনরুৎপাদন বৈশিষ্ট্যাবলী তার মা/দাদী/নানীর গুনাগুনের উপর নির্ভর করবে। তবে পাঁঠার দৈহিক বৈশিষ্ট্যাবলীর বিবেচনায় নির্বাচন করা যেতে পারে। ছাগী নির্বাচনে উৎপাদন ও পূনরুৎপাদন বৈশিষ্ট্যাবলী নিমড়বরূপ হবে।</p>
                <p className="card-text"><b>সারণী ১ঃ ছাগীর উৎপাদন/ পূনরুৎপাদন বৈশিষ্ট্যাবলী</b><br />
                    উৎপাদন ও পূনরুৎপাদন গুনাগুন<br /> ঘন ঘন বাচ্চা দেওয়ার ক্ষমতা ঃ বছরে কমপক্ষে ২ বার এবং প্রতিবার কমপক্ষে ২টি বাচ্চা<br />ন্যূনতম দৈনিক দুধ উৎপাদন ঃ ৬০০ মি.লি<br />প্রতিটি বাচ্চার জন্ম ওজন ঃ &gt;১ কেজি<br />বয়োঃপ্রাপ্তির বয়স ঃ ৪.৫ - ৫ মাস<br />বয়োঃপ্রাপ্তির ওজন ঃ &gt;১০ কেজি<br />দুগ্ধ প্রদানকাল ঃ ৩ মাস</p>
                <p className="card-text"><b>ছাগী নির্বাচন</b><br />লাভজনক বৱ্যাক বেঙ্গল ছাগল খামার প্রতিষ্ঠার জন্য সারণী-১ এ উলেখিত জাতের ছাগী নির্বাচনের ক্ষেত্রে দৈহিক যে সমস- গুনাবলী বিবেচনা প্রয়োজন তা নিমড়বরূপ। বিভিনড়ব বয়সে দৈহিক বৈশিষ্ট্যের তারতম্য হয়। সে কারণে একটি ছাগীর ৬-১২ মাস, ১২-২৪ মাস এবং ২৪ মাসের উর্দ্ধে বয়সের দৈহিক বৈশিষ্ট্যাবলী ভিনড়বভাবে তুলে ধরা হল।</p>
                <p>উনড়বত গুনাগুন সম্বলিত একটি ছাগীর নিমড়বলিখিত বৈশিষ্ট্যাবলী থাকা প্রয়োজন<br />
                    • মাথা ঃ চওড়া ও ছোট হবে<br />
                    • দৈহিক গঠন ঃ শরীর কৌনিক এবং অপ্রয়োজনীয় পেশীমুক্ত হবে<br />
                    • বুক ও পেট ঃ বুকের ও পেটের বেড় গভীর হবে<br />
                    • পাজরের হাড় ঃ পাজরের হাড় চওড়া এবং দুইটি হাড়ের মাঝখানে কমপক্ষে এক আঙ্গুল ফাঁকা জায়গা থাকবে<br />
                    • ওলান ঃ ওলানের দৈর্ঘ্য এবং প্রস' সামঞ্জস্যপূর্ণ থাকবে। বাঁটগুলো হবে আঙ্গুলের মত একই আকারের এবং<br />
                    • সমান-রালভাবে সাজানো। দুধের শিরা উলেৱখযোগ্যভাবে দেখা যাবে<br />
                    • বাহ্যিক অবয়ব ঃ আকর্ষণীয় চেহারা, ছাগী সুলভ আকৃতি, সামঞ্জস্যপূর্ণ ও নিখুঁত অঙ্গ-প্রত্যঙ্গ</p>
                <p className="card-text"><b>পাঁঠা নির্বাচন</b><br />লাভজনক বৱ্যাক বেঙ্গল ছাগল খামার প্রতিষ্ঠার জন্য উলেৱখিত জাতের পাঁঠা নির্বাচনের ক্ষেত্রে দৈহিক যে সমস- গুনাবলী বিবেচনাপ্রয়োজন তা নিমড়বরূপ। বিভিনড়ব বয়সে দৈহিক বৈশিষ্ট্যের তারতম্য হয়।</p>
                <p>উনড়বত গুনাগুন সম্বলিত একটি পাঁঠার নিমড়বলিখিত বৈশিষ্ট্যাবলী থাকা প্রয়োজন<br />
                    • চোখ : পরিষ্কার, বড় ও তীক্ষ্ণ দৃষ্টি সম্পনড়ব হবে<br />
                    • ঘাড় : খাটো ও মোটা থাকবে<br />
                    • বুক : গভীর ও প্রশস- হবে<br />
                    • পিঠ : প্রশস- হবে<br />
                    • লয়েন : প্রশস- ও পুরু এবং রাম্প এর উপরিভাগ সমতল ও লম্বা থাকবে<br />
                    • পা : সোজা, খাটো এবং মোটা হবে। বিশেষ করে পিছনের পাদ্বয় সুঠাম ও শক্তিশালী হবে এবং একটি হতে অন্যটি বেশ পৃথক থাকবে<br />
                    • অন্ডকোষ : শরীরের সাথে সামঞ্জস্যপূর্ণভাবে ঝুলানো থাকবে<br />
                    • বয়স : অধিক বয়স্ক (২ বছর বয়সের বেশী) পাঁঠা নির্বাচন করা যাবে না<br />
                </p>
                <p className="card-text"><b>ব্যবহারের সম্ভাবনা</b><br />সব ঋতুতে এবং সমগ্র বাংলাদেশে ব্যবহার উপযোগী।
                    <br /><b>প্রযুক্তি ব্যবহারের সতকর্তা/বিশেষ পরামর্শ</b><br />শুধুমাত্র উপরোলেখিত বৈশিষ্ট্যাবলীর উপর ভিত্তি করে ছাগী এবং পাঁঠা নির্বাচন করলে একটি খামার লাভবান হবে না। বরং উনড়বত ছাগল নির্বাচনসহ খাদ্য ব্যবস্থাপনা এবং সর্বোপরি সুষ্ঠু খামার ব্যবস্থাপনা করা হলে লাভজনক খামার প্রতিষ্ঠা সম্ভব।</p>

            </div>
        </div >


    );
};

export default DeshiChagolInfo;